import * as React from "react";
const SvgImageCircle = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.3725 13.6458L10.0799 12.4686C9.44588 11.8912 9.12889 11.6025 8.76965 11.4932C8.45326 11.3968 8.11537 11.3968 7.79898 11.4932C7.43973 11.6025 7.12275 11.8912 6.48877 12.4686L4.10033 14.6313M11.3725 13.6458L11.6358 13.4061C12.2698 12.8287 12.5868 12.54 12.946 12.4307C13.2624 12.3343 13.6003 12.3343 13.9167 12.4307C14.276 12.54 14.5929 12.8287 15.2269 13.4061L16.1864 14.2414M11.3725 13.6458L14.2058 16.2107M14.1667 7.5C14.1667 8.42047 13.4205 9.16667 12.5 9.16667C11.5795 9.16667 10.8333 8.42047 10.8333 7.5C10.8333 6.57953 11.5795 5.83333 12.5 5.83333C13.4205 5.83333 14.1667 6.57953 14.1667 7.5ZM17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgImageCircle;
